import * as BuildHelpers from './builder'

function groupCategoryVersion(data, version, result) {
  const versionByCategory = data.versions.find(categoryVersion => categoryVersion.version === version)

  if (versionByCategory) {
    const resultGroup = [...versionByCategory.result, ...result].sort()

    versionByCategory.result = resultGroup
  } else {
    data.versions = [
      ...data.versions,
      {
        version,
        result,
      },
    ]
  }
}

function groupDataByCategory(initialData) {
  return initialData.reduce((accData, dataItem) => {
    const { slug, category } = dataItem
    const version = BuildHelpers.buildVersion(dataItem)
    const result = BuildHelpers.buildResultList(dataItem)

    if (!category) {
      return accData
    }

    const dataItemByCategory = accData.find(item => item.category === category)

    if (dataItemByCategory) {
      groupCategoryVersion(dataItemByCategory, version, result, slug)
      return accData
    }

    const data = BuildHelpers.buildData(dataItem, version, result)
    return [...accData, data]
  }, [])
}

export { groupDataByCategory }
